import { useSyncExternalStore } from "react"
import { LayerGroup } from "react-leaflet"
import { dynamicPositionStore } from "./dynamicPositionStore"
import { rangeID } from "./Mapa"
import { Range } from "./Range"

export function RangeLayer(props: any){
    const rangeCoords = useSyncExternalStore(dynamicPositionStore.subscribe.bind(null, rangeID),dynamicPositionStore.getPlayerCord.bind(null, rangeID))

    if(rangeCoords === null){
        return(<></>)
    }


    return (
    <LayerGroup>
        <Range position={rangeCoords.coords} radius={rangeCoords.accuracy}></Range>
    </LayerGroup>
  )
}